module.exports = __webpack_public_path__ + "static/media/CI_.8f42c6d3.png";